import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/top-sel.png'
import _imports_2 from '@/assets/img/top-bt.png'


const _withScopeId = n => (_pushScopeId("data-v-c9244484"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_5 = { class: "items" }
const _hoisted_6 = { class: "item-content" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#contact",
    class: "mao"
  }, " 联系我们 ")
], -1))
const _hoisted_9 = { class: "desc" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub sub1" }, "海外互联网", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "sub sub2" }, "内容生态"),
  /*#__PURE__*/_createElementVNode("span", { class: "sub sub3" }, "综合服务商")
], -1))
const _hoisted_13 = { class: "tab-nav" }
const _hoisted_14 = { class: "item-content" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "sel"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "bt"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navs, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "item",
                key: item.label
              }, [
                _createElementVNode("a", {
                  href: `#${item.key}`,
                  class: "mao"
                }, _toDisplayString(item.label), 9, _hoisted_7)
              ]))
            }), 128)),
            _hoisted_8
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navs, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "item",
                  key: item.label
                }, [
                  _createElementVNode("a", {
                    href: `#${item.key}`,
                    class: "mao"
                  }, _toDisplayString(item.label), 9, _hoisted_15)
                ]))
              }), 128))
            ])
          ])
        ]),
        _hoisted_16
      ])
    ]),
    _hoisted_17
  ]))
}